import { Outlet } from "react-router-dom"
const MainMaterialExpense = () =>{
    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}

export default MainMaterialExpense;